<template>
	<svg
		class="size-4"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2448_36ero651)">
			<path
				d="M3.25008 9.99992C3.25008 8.57492 4.40841 7.41659 5.83342 7.41659H9.16675V5.83325H5.83342C3.53341 5.83325 1.66675 7.69992 1.66675 9.99992C1.66675 12.2999 3.53341 14.1666 5.83342 14.1666H9.16675V12.5833H5.83342C4.40841 12.5833 3.25008 11.4249 3.25008 9.99992ZM6.66675 10.8333H13.3334V9.16659H6.66675V10.8333ZM14.1667 5.83325H10.8334V7.41659H14.1667C15.5917 7.41659 16.7501 8.57492 16.7501 9.99992C16.7501 11.4249 15.5917 12.5833 14.1667 12.5833H10.8334V14.1666H14.1667C16.4667 14.1666 18.3334 12.2999 18.3334 9.99992C18.3334 7.69992 16.4667 5.83325 14.1667 5.83325Z"
				:fill="color"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2448_36651">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script setup>
const props = defineProps({
	color: {
		type: String,
		default: ''
	}
});
</script>
